import { gql } from '@efficiently/client-core-graphql-models';

export const DESIGN_CHANGE_CAPTURE_CONTEXT = gql(`
	query DesignChangeCaptureContext($projectFinishIds: [ID!]!) {
		designChangeCaptureContext(projectFinishIds: $projectFinishIds) {
			mustCapture
			preselectedDesignChangeId
			openDesignChanges {
				...ProjectDesignChange
			}
		}
	}
`);
